exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".avatar__1zVxl{width:40px;height:40px;min-width:40px;min-height:40px;max-width:40px;max-height:40px;background-color:#eee;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-o-object-fit:cover;object-fit:cover}", "", {"version":3,"sources":["/opt/build/repo/src/components/avatar/styles.scss"],"names":[],"mappings":"AAEA,eACE,WACA,YACA,eACA,gBACA,eACA,gBACA,sBACA,kBACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,oBAAA,gBAAiB,CAClB","file":"styles.scss","sourcesContent":["@import '../../variables';\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  min-height: 40px;\n  max-width: 40px;\n  max-height: 40px;\n  background-color: $gray-200;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"avatar": "avatar__1zVxl"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/avatar/styles.scss
// module id = qphB
// module chunks = 0